import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
import { firebaseConfig } from './firebase-config'
import Toasted from 'vue-toasted'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(Toasted, {
  theme: "bubble",
  position: "bottom-center",
  fitToScreen: true,
  duration: 4000
})

firebase.initializeApp(firebaseConfig)
firebase.analytics()

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
if (localStorage.getItem('locale') !== null) {
  i18n.locale = localStorage.getItem('locale');
}
else {
  if (navigator.language.includes("ja")) {
    i18n.locale = "ja";
  } else {
    i18n.locale = "en";
  }
}
